export const SCHEDULE_COLUMNS = ['L', 'M', 'X', 'J', 'V'];

export const WEEKLY_SCHEDULE = [
  {
    activity: 'Bujinkan Unryukai',
    morning: {
      L: '10:00 - 11:30',
      M: '-',
      X: '-',
      J: '10:00 - 11:30',
      V: '-'
    },
    afternoon: {
      L: '-',
      M: '20:00 - 21:30',
      X: '-',
      J: '20:00 - 21:30',
      V: '18:00 - 19:00'
    }
  },
  {
    activity: 'Yoga',
    morning: {
      L: '-',
      M: '-',
      X: '-',
      J: '-',
      V: '-'
    },
    afternoon: {
      L: '-',
      M: '-',
      X: '18:30 - 19:30',
      J: '-',
      V: '-'
    }
  },
  {
    activity: 'Chi Kung',
    morning: {
      L: '-',
      M: '10:00 - 11:00',
      X: '-',
      J: '-',
      V: '-'
    },
    afternoon: {
      L: '18:00 - 19:00',
      M: '-',
      X: '-',
      J: '-',
      V: '-'
    }
  },
  {
    activity: 'Defensa Personal',
    morning: {
      L: '-',
      M: '-',
      X: '-',
      J: '-',
      V: '-'
    },
    afternoon: {
      L: '19:30 - 20:30',
      M: '-',
      X: '17:15 - 18:15',
      J: '-',
      V: '-'
    }
  },
  {
    activity: 'Terapias Balance',
    singleCell: 'Bajo cita previa (mañana y tarde, lunes a viernes)'
  }
];
